<template>
	<div v-if="chartsGroups.length">
	    <template 
	    	v-for="chartGroup in chartsGroups" 
	    	:key="chartGroup.index"
    		>
	    	<div
	    		class="dashboard-grid-items-wrapper"
	    		:class="`vr-row-${ chartGroup.vertical_ratio }`"
	    		>
	    		<template v-for="chartData in chartGroup.charts" :key="chartData.index">
	    			<!-- {% include [ 'components/charts/chart-' ~ chart_data.type ~ '.twig', 'components/charts/chart-piechart.twig' ] with {chart_class: 'single-item'} %}	 -->
	    			<!-- <pre style="width: 100vw">{{ chartData}}</pre> -->
	    			<ChartComponent 
	    				:index="chartData.index"
	    				:chartData="chartData"
	    				:chartClass="chartData.chart_class"
	    				/>
    				<!-- </template> -->
	    		</template>
	        </div>
	    </template>
    </div>
</template>
<script>
import ChartComponent from '@vueapp/components/ChartComponent.vue'
export default {
	name: 'DashboardComponent',
	components: {
		ChartComponent
	},
	props: {
		chartsGroups: {
			type: Array,
			required: true,
			default: []
		}
	}

}
</script>